import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/login.vue'
import Home from '../views/home.vue'
import EquipmentList from '../views/equipmentList.vue'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/equipmentList',
    name: 'equipmentList',
    component: EquipmentList
  }
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  if(to.path == '/'){
     const userId = localStorage.getItem('userId')
     if(userId){
         next('/home')
     }else{
         next('/login')
     }
  }else{
      next()
  }
});
export default router
